import { render } from "./MemberYgd.vue?vue&type=template&id=3777050e"
import script from "./MemberYgd.vue?vue&type=script&lang=js"
export * from "./MemberYgd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__